import {
  getApiUrl,
  getPlannerAppUrl,
  getSFIntegrationUrl,
} from './utils/environment';

interface Config {
  apiUrl: string;
  authentication: Authentication;
  sfIntegrationUrl: string;
  plannerUrl: string;
  googleMapsAPIKey: string;
}

interface Authentication {
  clientId: string;
  tenantId: string;
  scopes: string[];
}

const config: Config = {
  /// TODO: need to change when the new domains is available for rest of the env
  apiUrl: `https://fulfilment-api${getApiUrl()}.craftos.enpal.tech/api/v1.0`,
  sfIntegrationUrl: getSFIntegrationUrl(),
  plannerUrl: getPlannerAppUrl(),
  googleMapsAPIKey: 'AIzaSyA1iBH7daoW6fdbrely5sTSX6qkIjJ9pq8', //prod
  //googleMapsAPIKey: 'AIzaSyB6CWGBA60jLfACZhqA1Kb53MPed5FMqVc', // my local
  authentication: {
    clientId: '42eab713-24c8-45ab-95d6-cfdaa8d8d6e0',
    tenantId: 'd22da9a6-d89a-4764-9d56-96b020869dff',
    scopes: [
      'openid',
      'profile',
      'offline_access',
      'https://enpalcraftos.onmicrosoft.com/api/craftos/Forms.Read',
      'https://enpalcraftos.onmicrosoft.com/api/craftos/foo',
    ],
  },
};

export { config };
